import {Swal, ClipboardJS} from "./vendor";
import {ajaxPost, parceAjaxErrorResponse} from "./js/utils";
import {bsToast} from "./js/plugins";
import {Tooltip} from "bootstrap";

let jsContext = {};
const jsContextJson = $("#js_context");
if (jsContextJson.length > 0) {
  jsContext = JSON.parse(jsContextJson.text());
}

export const getJsContext = (key) => {
  if (!(key in jsContext)) {
    return key;
  }
  return jsContext[key];
};

export const getUrlTranslation = (url) => {
  const lang = document.querySelector("html").getAttribute("lang");
  if (lang === "az") {
    return url;
  }

  return `/${lang}${url}`;
}

export const WimsSwal = Swal.mixin({
  customClass: {
    title: "ms-2",
    actions: "ps-2",
    confirmButton: "btn btn-primary px-5 m-2",
    cancelButton: "btn btn-secondary px-5 m-2",
    denyButton: "btn btn-secondary px-5 m-2",
  },
  buttonsStyling: false,
  heightAuto: false,
});

export const SwalPost = (url, data, options = {}) => {
  return new Promise((resolve, reject) => {
    WimsSwal.fire({
      text: getJsContext('are_you_sure_to_perform_this_action'),
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: getJsContext('yes_perform'),
      cancelButtonText: getJsContext('no_cancel'),
      heightAuto: false,
      ...options,
    }).then((result) => {
      if (result.isConfirmed) {
        WimsSwal.fire({
          icon: "info",
          text: getJsContext('please_wait') + '...',
        });
        ajaxPost(url, data)
          .then((response) => {
            resolve(response);
          })
          .catch((errors) => {
            const errorList = parceAjaxErrorResponse(errors);
            ErrorSwal.fire({html: errorList.join("<br>")}).then(() => {
              reject(errors);
            });
          })
          .finally(() => {
            Swal.close;
          });
      } else {
        reject('Swal: "No, cancel" button clicked.');
      }
    });
  });
};

export const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  buttonsStyling: false,
  timer: 3000,
  timerProgressBar: true,
  customClass: {
    title: "ms-2",
    actions: "ps-2",
    confirmButton: "btn btn-primary px-5 m-2",
    cancelButton: "btn btn-secondary px-5 m-2",
    denyButton: "btn btn-secondary px-5 m-2",
  },
  didOpen: (toast) => {
    toast.addEventListener("mouseenter", Swal.stopTimer);
    toast.addEventListener("mouseleave", Swal.resumeTimer);
    toast.addEventListener("click", Swal.close);
  },
});

export const SuccessSwal = WimsSwal.mixin({
  icon: "success",
  text: getJsContext('operation_successfully_performed'),
});

export const ErrorSwal = WimsSwal.mixin({
  icon: "error",
  titleText: getJsContext('error_occurred'),
  text: getJsContext('error_occurred_on_request_to_server'),
});

export const AlertSwal = WimsSwal.mixin({
  showCancelButton: true,
  confirmButtonText: getJsContext('yes_perform'),
  cancelButtonText: getJsContext('no_cancel'),
});

export const SuccessToast = WimsSwal.mixin({
  // title: 'Əla!',
  text: getJsContext('operation_successfully_performed'),
  icon: "success",
  toast: true,
  position: "bottom-end",
  showConfirmButton: false,
  timer: 3000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener("mouseenter", Swal.stopTimer);
    toast.addEventListener("mouseleave", Swal.resumeTimer);
    toast.addEventListener("mouseclick", Swal.close);
  },
});

import './js/find-policy-number';
import './js/admin';
import './js/policy';
import './js/subrogation';
import './js/payment-details';
import './js/pay';

window.addEventListener("offline", () => {
  $("#connectivity").remove();
  $("body").append(
    `<div id="connectivity" class="offline">${getJsContext('no_internet_connection')}</div>`,
  );
});

window.addEventListener("online", () => {
  $("#connectivity").remove();
  $("body").append(
    `<div id="connectivity" class="online">${getJsContext('internet_connection_restored')}</div>`,
  );
  setTimeout(() => {
    $("#connectivity").fadeOut(500, () => {
      $("#connectivity").remove();
    });
  }, 3000);
});

$('body').find('[data-bs-toggle="tooltip"]').each((_, el) => {
  new Tooltip(el);
});

$('.copyDebtToPaymentAmount').on('click', (e) => {
  const button = $(e.target);
  const buttonParent = button.closest('.input-group');
  const debtInput = buttonParent.find('input');

  const paymentAmountInput = $('input[name=payment_amount]');

  paymentAmountInput.val(debtInput.val());
  paymentAmountInput.trigger('input');
  paymentAmountInput.focus();
});

new ClipboardJS("button.clipboard").on("success", function (e) {
  bsToast({
    title: getJsContext('copied'),
    content: getJsContext('text_copied') + ": " + e.text,
  });

  e.clearSelection();
});

const clearableInput = $('.input-clearable');
if (clearableInput.length) {
  const toggleClearInput = (input) => {
    if (input.val().length !== 0) {
      input.closest('div').find('button.clear-input').fadeIn();
    } else {
      input.closest('div').find('button.clear-input').hide();
    }
  }

  clearableInput.each((_, el) => {
    $(el).closest('div')
      .append(`<button class="clear-input" type="button" style="display: none;">×</button>`);
    toggleClearInput($(el));
  });

  clearableInput.on('input', (e) => {
    toggleClearInput($(e.target));
  });

  clearableInput.closest('div').find('button.clear-input').on('click', (e) => {
    $(e.target).closest('div').find('input').val('').focus();
    $(e.target).hide();
  });
}

$(".columnCollapseBtn").on("click", function () {
  $(this).closest(".block-small-column").toggleClass("collapsed");
});

$(".form-control-datepicker").flatpickr({
  dateFormat: "d.m.Y",
  allowInput: true,
  mode: "range",
});

$.fn.dataTable.ext.errMode = function (settings, helpPage, message) {
  if (settings.jqXHR.status >= 500) {
    bsToast({
      title: getJsContext('error') + "!",
      content: getJsContext('server_error'),
    });
    console.error(settings, helpPage, message);
  } else if (settings.jqXHR.status === 464) {
    window.location.href = settings.jqXHR["responseJSON"]["redirect_url"];
  }
};

// reCAPTCHA v3
export const getRecaptchaToken = (form, formLoadingConf = {}) => {
  $(form).loading({
    loadingText: getJsContext('checking_recaptcha') + '...',
    position: "left top",
    extraClasses: "w110 p-4",
    ...formLoadingConf
  });
  return new Promise((resolve, reject) => {
    grecaptcha.ready(async () => {
      try {
        grecaptcha.execute(getJsContext('RECAPTCHA_PUBLIC_KEY'), {action: 'homepage'})
          .then((token) => {
            $(form).loading({action: "hide"});
            const reCaptchaInput = `<input type="hidden" name="recaptcha" value="${token}">`
            if ($(form).find('input[name=recaptcha]').length) {
              $(form).find('input[name=recaptcha]').replaceWith(reCaptchaInput);
            } else {
              $(form).prepend(reCaptchaInput)
            }
            resolve(true);
          })
      } catch (Error) {
        $(form).loading({action: "hide"});
        ErrorSwal.fire({
          titleText: getJsContext('error') + "!",
          text: getJsContext('recaptcha_error'),
        }).then(() => {
          reject(Error);
        })
      }
    });
  })
}
